import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AdminDebugSubscription200,
  AdminDebugSubscription404,
  AdminDebugSubscription500,
  CancelAdminAccountSubscription200,
  CancelAdminAccountSubscription400,
  CancelAdminAccountSubscription403,
  CancelAdminAccountSubscriptionBody,
  GetAdminAccountPaymentDebug200,
  GetAdminAccountPaymentDebug400,
  GetAdminAccountPaymentDebug403,
  GetAdminAccountPaymentDebugParams,
  GetAdminAccountPaymentSummaries200Item,
  GetAdminAccountPaymentSummaries400,
  GetAdminAccountPaymentSummaries403,
  GetAdminAccountPaymentSummariesParams,
  GetAdminUserSubscriptions200,
  GetAdminUserSubscriptions404,
  GetAdminUserSubscriptions500,
  GetAdminUserSubscriptionsV2200,
  RequestAdminAccountRefund200,
  RequestAdminAccountRefund400,
  RequestAdminAccountRefund403,
  RequestAdminAccountRefundBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary 관리자용 사용자 구독 조회 (v2)
 */
export const getAdminUserSubscriptionsV2 = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAdminUserSubscriptionsV2200>(
      {url: `/api/v1/admin/users/${userId}/subscriptions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminUserSubscriptionsV2QueryKey = (userId: string,) => {
    return [`/api/v1/admin/users/${userId}/subscriptions`] as const;
    }

    
export const getGetAdminUserSubscriptionsV2InfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError = unknown>(userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserSubscriptionsV2QueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>> = ({ signal }) => getAdminUserSubscriptionsV2(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserSubscriptionsV2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>>
export type GetAdminUserSubscriptionsV2InfiniteQueryError = unknown

/**
 * @summary 관리자용 사용자 구독 조회 (v2)
 */
export const useGetAdminUserSubscriptionsV2Infinite = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError = unknown>(
 userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUserSubscriptionsV2InfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAdminUserSubscriptionsV2QueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError = unknown>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserSubscriptionsV2QueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>> = ({ signal }) => getAdminUserSubscriptionsV2(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserSubscriptionsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>>
export type GetAdminUserSubscriptionsV2QueryError = unknown

/**
 * @summary 관리자용 사용자 구독 조회 (v2)
 */
export const useGetAdminUserSubscriptionsV2 = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError = unknown>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUserSubscriptionsV2QueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 사용자의 현재 구독 상태와 최근 주문 기록을 조회합니다.
 * @summary 관리자용 계정 결제 디버그 조회
 */
export const getAdminAccountPaymentDebug = (
    params: GetAdminAccountPaymentDebugParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAdminAccountPaymentDebug200>(
      {url: `/api/v1/admin/accounts/payment-debug`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminAccountPaymentDebugQueryKey = (params: GetAdminAccountPaymentDebugParams,) => {
    return [`/api/v1/admin/accounts/payment-debug`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminAccountPaymentDebugInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError = GetAdminAccountPaymentDebug400 | GetAdminAccountPaymentDebug403>(params: GetAdminAccountPaymentDebugParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAccountPaymentDebugQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>> = ({ signal }) => getAdminAccountPaymentDebug(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAccountPaymentDebugInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>>
export type GetAdminAccountPaymentDebugInfiniteQueryError = GetAdminAccountPaymentDebug400 | GetAdminAccountPaymentDebug403

/**
 * @summary 관리자용 계정 결제 디버그 조회
 */
export const useGetAdminAccountPaymentDebugInfinite = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError = GetAdminAccountPaymentDebug400 | GetAdminAccountPaymentDebug403>(
 params: GetAdminAccountPaymentDebugParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminAccountPaymentDebugInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAdminAccountPaymentDebugQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError = GetAdminAccountPaymentDebug400 | GetAdminAccountPaymentDebug403>(params: GetAdminAccountPaymentDebugParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAccountPaymentDebugQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>> = ({ signal }) => getAdminAccountPaymentDebug(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAccountPaymentDebugQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>>
export type GetAdminAccountPaymentDebugQueryError = GetAdminAccountPaymentDebug400 | GetAdminAccountPaymentDebug403

/**
 * @summary 관리자용 계정 결제 디버그 조회
 */
export const useGetAdminAccountPaymentDebug = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError = GetAdminAccountPaymentDebug400 | GetAdminAccountPaymentDebug403>(
 params: GetAdminAccountPaymentDebugParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminAccountPaymentDebugQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 사용자 목록에 표시할 앱별 구독 요약을 일괄 조회합니다.
 * @summary 관리자용 계정 결제 요약 조회
 */
export const getAdminAccountPaymentSummaries = (
    params: GetAdminAccountPaymentSummariesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAdminAccountPaymentSummaries200Item[]>(
      {url: `/api/v1/admin/accounts/payment-summaries`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminAccountPaymentSummariesQueryKey = (params: GetAdminAccountPaymentSummariesParams,) => {
    return [`/api/v1/admin/accounts/payment-summaries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminAccountPaymentSummariesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError = GetAdminAccountPaymentSummaries400 | GetAdminAccountPaymentSummaries403>(params: GetAdminAccountPaymentSummariesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAccountPaymentSummariesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>> = ({ signal }) => getAdminAccountPaymentSummaries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAccountPaymentSummariesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>>
export type GetAdminAccountPaymentSummariesInfiniteQueryError = GetAdminAccountPaymentSummaries400 | GetAdminAccountPaymentSummaries403

/**
 * @summary 관리자용 계정 결제 요약 조회
 */
export const useGetAdminAccountPaymentSummariesInfinite = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError = GetAdminAccountPaymentSummaries400 | GetAdminAccountPaymentSummaries403>(
 params: GetAdminAccountPaymentSummariesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminAccountPaymentSummariesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAdminAccountPaymentSummariesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError = GetAdminAccountPaymentSummaries400 | GetAdminAccountPaymentSummaries403>(params: GetAdminAccountPaymentSummariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAccountPaymentSummariesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>> = ({ signal }) => getAdminAccountPaymentSummaries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAccountPaymentSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>>
export type GetAdminAccountPaymentSummariesQueryError = GetAdminAccountPaymentSummaries400 | GetAdminAccountPaymentSummaries403

/**
 * @summary 관리자용 계정 결제 요약 조회
 */
export const useGetAdminAccountPaymentSummaries = <TData = Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError = GetAdminAccountPaymentSummaries400 | GetAdminAccountPaymentSummaries403>(
 params: GetAdminAccountPaymentSummariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminAccountPaymentSummariesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 사용자의 주문에 대해 관리자 권한으로 환불 요청을 생성합니다.
 * @summary 관리자용 환불 요청 생성
 */
export const requestAdminAccountRefund = (
    requestAdminAccountRefundBody: RequestAdminAccountRefundBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RequestAdminAccountRefund200>(
      {url: `/api/v1/admin/accounts/refund-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAdminAccountRefundBody
    },
      options);
    }
  


export const getRequestAdminAccountRefundMutationOptions = <TError = RequestAdminAccountRefund400 | RequestAdminAccountRefund403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAdminAccountRefund>>, TError,{data: RequestAdminAccountRefundBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAdminAccountRefund>>, TError,{data: RequestAdminAccountRefundBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAdminAccountRefund>>, {data: RequestAdminAccountRefundBody}> = (props) => {
          const {data} = props ?? {};

          return  requestAdminAccountRefund(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestAdminAccountRefundMutationResult = NonNullable<Awaited<ReturnType<typeof requestAdminAccountRefund>>>
    export type RequestAdminAccountRefundMutationBody = RequestAdminAccountRefundBody
    export type RequestAdminAccountRefundMutationError = RequestAdminAccountRefund400 | RequestAdminAccountRefund403

    /**
 * @summary 관리자용 환불 요청 생성
 */
export const useRequestAdminAccountRefund = <TError = RequestAdminAccountRefund400 | RequestAdminAccountRefund403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAdminAccountRefund>>, TError,{data: RequestAdminAccountRefundBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof requestAdminAccountRefund>>,
        TError,
        {data: RequestAdminAccountRefundBody},
        TContext
      > => {

      const mutationOptions = getRequestAdminAccountRefundMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 사용자의 특정 구독을 관리자 권한으로 취소합니다.
 * @summary 관리자용 구독 취소
 */
export const cancelAdminAccountSubscription = (
    cancelAdminAccountSubscriptionBody: CancelAdminAccountSubscriptionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CancelAdminAccountSubscription200>(
      {url: `/api/v1/admin/accounts/cancel-subscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelAdminAccountSubscriptionBody
    },
      options);
    }
  


export const getCancelAdminAccountSubscriptionMutationOptions = <TError = CancelAdminAccountSubscription400 | CancelAdminAccountSubscription403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAdminAccountSubscription>>, TError,{data: CancelAdminAccountSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAdminAccountSubscription>>, TError,{data: CancelAdminAccountSubscriptionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAdminAccountSubscription>>, {data: CancelAdminAccountSubscriptionBody}> = (props) => {
          const {data} = props ?? {};

          return  cancelAdminAccountSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelAdminAccountSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAdminAccountSubscription>>>
    export type CancelAdminAccountSubscriptionMutationBody = CancelAdminAccountSubscriptionBody
    export type CancelAdminAccountSubscriptionMutationError = CancelAdminAccountSubscription400 | CancelAdminAccountSubscription403

    /**
 * @summary 관리자용 구독 취소
 */
export const useCancelAdminAccountSubscription = <TError = CancelAdminAccountSubscription400 | CancelAdminAccountSubscription403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAdminAccountSubscription>>, TError,{data: CancelAdminAccountSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelAdminAccountSubscription>>,
        TError,
        {data: CancelAdminAccountSubscriptionBody},
        TContext
      > => {

      const mutationOptions = getCancelAdminAccountSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
 * @summary 관리자용 사용자 구독 조회
 */
export const getAdminUserSubscriptions = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAdminUserSubscriptions200>(
      {url: `/api/v1/admin/subscriptions/users/${userId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminUserSubscriptionsQueryKey = (userId: string,) => {
    return [`/api/v1/admin/subscriptions/users/${userId}`] as const;
    }

    
export const getGetAdminUserSubscriptionsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError = GetAdminUserSubscriptions404 | GetAdminUserSubscriptions500>(userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserSubscriptionsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserSubscriptions>>> = ({ signal }) => getAdminUserSubscriptions(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserSubscriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserSubscriptions>>>
export type GetAdminUserSubscriptionsInfiniteQueryError = GetAdminUserSubscriptions404 | GetAdminUserSubscriptions500

/**
 * @summary 관리자용 사용자 구독 조회
 */
export const useGetAdminUserSubscriptionsInfinite = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError = GetAdminUserSubscriptions404 | GetAdminUserSubscriptions500>(
 userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUserSubscriptionsInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAdminUserSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError = GetAdminUserSubscriptions404 | GetAdminUserSubscriptions500>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserSubscriptionsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserSubscriptions>>> = ({ signal }) => getAdminUserSubscriptions(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserSubscriptions>>>
export type GetAdminUserSubscriptionsQueryError = GetAdminUserSubscriptions404 | GetAdminUserSubscriptions500

/**
 * @summary 관리자용 사용자 구독 조회
 */
export const useGetAdminUserSubscriptions = <TData = Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError = GetAdminUserSubscriptions404 | GetAdminUserSubscriptions500>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUserSubscriptionsQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 구독의 상세 디버그 정보를 조회합니다
 * @summary 관리자용 구독 디버그
 */
export const adminDebugSubscription = (
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminDebugSubscription200>(
      {url: `/api/v1/admin/subscriptions/${subscriptionId}/debug`, method: 'GET', signal
    },
      options);
    }
  

export const getAdminDebugSubscriptionQueryKey = (subscriptionId: string,) => {
    return [`/api/v1/admin/subscriptions/${subscriptionId}/debug`] as const;
    }

    
export const getAdminDebugSubscriptionInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof adminDebugSubscription>>, TError = AdminDebugSubscription404 | AdminDebugSubscription500>(subscriptionId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminDebugSubscription>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminDebugSubscriptionQueryKey(subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDebugSubscription>>> = ({ signal }) => adminDebugSubscription(subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(subscriptionId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminDebugSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminDebugSubscriptionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminDebugSubscription>>>
export type AdminDebugSubscriptionInfiniteQueryError = AdminDebugSubscription404 | AdminDebugSubscription500

/**
 * @summary 관리자용 구독 디버그
 */
export const useAdminDebugSubscriptionInfinite = <TData = Awaited<ReturnType<typeof adminDebugSubscription>>, TError = AdminDebugSubscription404 | AdminDebugSubscription500>(
 subscriptionId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminDebugSubscription>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminDebugSubscriptionInfiniteQueryOptions(subscriptionId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminDebugSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof adminDebugSubscription>>, TError = AdminDebugSubscription404 | AdminDebugSubscription500>(subscriptionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminDebugSubscription>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminDebugSubscriptionQueryKey(subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDebugSubscription>>> = ({ signal }) => adminDebugSubscription(subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(subscriptionId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminDebugSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminDebugSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof adminDebugSubscription>>>
export type AdminDebugSubscriptionQueryError = AdminDebugSubscription404 | AdminDebugSubscription500

/**
 * @summary 관리자용 구독 디버그
 */
export const useAdminDebugSubscription = <TData = Awaited<ReturnType<typeof adminDebugSubscription>>, TError = AdminDebugSubscription404 | AdminDebugSubscription500>(
 subscriptionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminDebugSubscription>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminDebugSubscriptionQueryOptions(subscriptionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



